import { ActionTree } from 'vuex';
import { AuthState } from './types';
import { StoreState } from '@/types';
import authApi from '@/services/auth';
import storage from '@/helpers/storage';
import moment from 'moment';
import { load } from '@/helpers/storage';

import { NSLog } from '@/helpers/log';
const log = NSLog('store/auth/action');

const actions: ActionTree<AuthState, StoreState> = {
  async init({ commit, dispatch }) {
    const token = load('token', null);
    if (token) {
      commit('setToken', token);

      // monitor sessionState
      dispatch('sessionMonitor');
    }
  },

  // gotoLogin(returnUrl){
  //  const login_remote_url = 'https://accounts.hearxgroup.com'
  //   let hex = btoa(JSON.stringify({
  //    continue_to: 'http://127.0.0.1:8080/auth',
  //    continue_to_name: "Continue to Billing Admin"
  //   }))

  //   window.location.href = `${login_remote_url}?continue=${hex}`
  // },

  async login({ commit, dispatch, getters }, loginReq) {
    // dispatch('gotoLogin')
    // return

    // ======= get backend token ======= \\
    // commit('setState', 'logging in');
    let beInfo = null;
    try {
      beInfo = await authApi.login(loginReq);
    } catch (err) {
      commit('clearState');
      throw err;
    }
    if (!beInfo) {
      commit('clearState');
      throw new Error("Email or password incorrect");
    }
    commit('setToken', beInfo.token);

    if (!getters.hasPermission(['accounts.can_read', 'adminviews.can_read', 'orderingadmin.can_read'])) {
      commit('clearState');
      commit('setToken', '');
      throw new Error("You do not have the correct permissions to log in to this portal");
    }

    await dispatch('authenticated', false, { root: true });

    // monitor sessionState
    dispatch('sessionMonitor');

    commit('clearState');
    return true;
  },

  // repeat auto login 1 hours before token expires
  sessionMonitor({ state, dispatch }) {
    setInterval(() => {
      if (!state.token) { return; }
      const secondsRemaining = state.sessionTimeoutUnix - moment().unix();
      if (secondsRemaining < (60 * 60 * 1)) {
        dispatch('logout');
      }
    }, 5000);
  },

  async logout({ commit, dispatch }) {
    commit('logout');
    try {
      storage.clear();
      dispatch('reload', false, { root: true });
    } catch (err) {
      log(err);
      throw err;
    }
  },
};

export default actions;
